
import React, { useEffect, useState, useRef } from 'react';
import { ApiService } from '../../containers/Services/apiservice';
import { Link } from "react-router-dom";
import Footer from "../../containers/Footer";
import Header from "../../containers/Header";
import { useHistory } from 'react-router-dom';
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
function InvestorConcent() {
  let history = useHistory();
  const didMountRef = useRef(true);
  const [spinnerLoading, setSpinnerLoading] = useState('')
  const [refId, setRefid] = useState('')
  const [checkStatus, setCheckStatus] = useState('')
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    if (didMountRef.current) {
    }
    didMountRef.current = false;
  });
  const giveconcent = () => {
    setLoader(true);
    const dataString = {
    }
    apiServices.getinvestorconcentPostRequest(dataString).then(result => {
      if (result.data.respStatus && result.data.respStatus == 0 && result.data.entryDet.priLink != '') {
        openInNewTab(result.data.entryDet.priLink);
        setLoader(false);
      } else if (result.data.respStatus == 1 && result.data.errorMessage) {
        alert(result.data.errorMessage);
        setLoader(false);
        return false;
      }
      else if (result.data.status == "error" && result.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(result.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert('Something Went Wrong');
        setLoader(false);
       return false;
      }
    })
  }
  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
  const checkconcentstatus = () => {
    history.push("/dashboard");
  }
  // const checkconcentstatus=()=>{
  //     let data = JSON.parse(localStorage.getItem('user'));
  //     setLoader(true);
  //     const dataString = {
  //       "user_id": data.gs_id
  //       } 
  //       apiServices.getcheckconcentstatusPostRequest(dataString).then(result => {
  //         console.log(result)
  //       if(result.data.respStatus == 0 && result.data.consetDetObj.status=="AP"){
  //            alert("Your Concent has been approved")
  //            history.push("/dashboard");
  //            setLoader(false);

  //       }else if(result.data.respStatus == 1 && result.data.errorMessage)
  //       {
  //         alert(result.data.errorMessage);
  //         setLoader(false);
  //         return false;
  //       }
  //       else{
  //         alert(result.data)
  //         setLoader(false);
  //       }
  //       })
  // }
  return (
    <>
      {/* <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
        <div className='overlay-box'>     
            <Watch
                color="#ffffff"
                visible={spinnerLoading}
                />
            </div>
                </div> */}
      <Header />
      <section>
        <div className={loader == true ? 'parentDisable' : ''} width="100%">
          <div className='overlay-box'>
            <Watch
              color="#ffffff"
              visible={loader}
            />
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-md-center">
            <div className='col-lg-8 tx-center'>
              <div className="row" style={{ marginTop: "-40px" }}>
                <div className="" role="">
                  <div><h5>Provide Consent for One Glance Statement</h5></div>
                  <div className='mg-t-50'>
                    <p>Provide Consent to display <b>complete portfolio</b> under your CAN, even the one invested with other brokers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-lg-4 tx-center mg-t-30'>
              <button type="submit" onClick={giveconcent} className="buttonab-line "><b>Provide Consent <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></b></button>
            </div>
            {/* <button className="" style={{marginRight: "10px"}} onClick={giveconcent}>Provide Consent<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i> </button> */}
            {/* <Link to="/mutualfunds/purchase" className="btn btn-primary newsletter-button mb-2 "  >Not Intrested</Link><br/> */}
            <div className='col-lg-4 tx-center mg-t-30'>
              <button type="submit" onClick={checkconcentstatus} className="buttonab-line "><b>Skip For Now  <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></b></button>
            </div>
            {/* <button className="" onClick={checkconcentstatus}>Skip For Now <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i> </button> */}
          </div>
          <div className="row justify-content-md-center mg-t-30" >
            <p><b>Benefits of providing Consent : </b>You have to provide your consent one time for us to enable your complete one glance statement.
              You can view and transact all you funds, invested with any broker in folio form (Not in Demat Form) from
              one single dashboard. </p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}
export default InvestorConcent;